import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { useAuth } from 'context/auth-context';
import { useLocation } from 'react-router-dom';

import ProgramCalendar from './components/ProgramCalendar';
import ProgramsPageHeader from './components/ProgramsPageHeader';
import { FilterTerms, ProgrammingNavState, ProgrammingTab } from './components/types';

const Scheduling = (): JSX.Element => {
  const initialSearchFiltersValue = {
    kiloClassTypes: [],
  };
  const { hasPerm } = useAuth();

  const programmingPerm = hasPerm('ProgramMutate');

  const navState = useLocation().state as ProgrammingNavState | null;
  const [activeTab, setActiveTab] = useState<ProgrammingTab>(navState?.tab ?? 'classes');
  const [searchFilters, setSearchFilters] = useState<FilterTerms>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<FilterTerms>(searchFilters, 250);

  return (
    <>
      <ProgramsPageHeader
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <ProgramCalendar
        activeTab={activeTab}
        searchFilters={debouncedSearchFilters}
        permission={programmingPerm}
      />
    </>
  );
};

export default Scheduling;
